import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, filter, first, from, switchMap, throwError } from 'rxjs';

import { AuthStore } from './state/auth.store';

export const authInterceptor: HttpInterceptorFn = (request, handler) => {
  const authStore = inject(AuthStore);

  return authStore.authToken$.pipe(
    filter(Boolean),
    first(),
    switchMap((token) =>
      handler(
        request.clone({
          headers: request.headers.set('Authorization', `Bearer ${token}`),
        }),
      ).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            return from(authStore.refreshToken()).pipe(
              switchMap((newToken) =>
                newToken
                  ? handler(
                      request.clone({
                        headers: request.headers.set('Authorization', `Bearer ${newToken}`),
                      }),
                    )
                  : throwError(() => error),
              ),
            );
          }
          return throwError(() => error);
        }),
      ),
    ),
  );
};
